import { Request } from 'api';
import { AxiosResponse } from 'axios';
import { Calendar } from 'utils';

type ReturnType = Promise<AxiosResponse<Array<Calendar>>>;

const viewAllCalendars = (): ReturnType => {
    return Request.get(`/calendar/calendars`);
};

export default viewAllCalendars;
